import { Component, Input, OnInit } from '@angular/core';
import { DataTableColumn } from '../../../shared/ui/data-table/data-table.component';
import { splitData } from '../../../shared/utils/format.util';

const MANAGER_COLUMNS: DataTableColumn[] = [
  { field: 'name',                          header: 'Challenge',       align: 'left' },
  { field: 'quarterlyBookings',             header: 'Bookings',        align: 'center', prefix: '$' },
  { field: 'totalSellersEnrolledInProgram', header: 'Participants',    align: 'center' },
  { field: 'totalClaimsSubmitted',          header: 'Claims',          align: 'center' },
  { field: 'totalBookingsClaimedBySellers', header: 'Claimed Value',   align: 'center', prefix: '$' },
  { field: 'bookingsLeftUnclaimed',         header: 'Pending',         align: 'center', highlight: 'orange' },
  { field: 'totalPointsAvailable',          header: 'Points Available', align: 'center' },
  { field: 'totalSellerPointsAwarded',      header: 'Points Earned',   align: 'center', highlight: 'green', isBold: true },
];

const SELLER_COLUMNS: DataTableColumn[] = [
  { field: 'name',            header: 'Challenge',        align: 'center' },
  { field: 'bookings',        header: 'Bookings',         align: 'center' },
  { field: 'claimsSubmitted', header: 'Claims Submitted', align: 'center' },
  { field: 'claimsPending',   header: 'Claims Pending',   align: 'center', highlight: 'orange' },
  { field: 'pointsEarned',    header: 'Points Earned',    align: 'center', highlight: 'green' },
];

@Component({
  selector: 'app-dashboard-sales-challenges',
  templateUrl: './dashboard-sales-challenges.component.html',
  styleUrls: ['./dashboard-sales-challenges.component.scss']
})
export class DashboardSalesChallengesComponent implements OnInit {

  @Input() role: 'manager' | 'seller' = 'seller';
  @Input() dashboardData: any = null;
  @Input() isLoading = false;
  @Input() isChallengePreference = false;

  columns: DataTableColumn[] = [];

  readonly pageSize = 5;
  page = 1;

  ngOnInit() {
    this.columns = this.role === 'manager' ? MANAGER_COLUMNS : SELLER_COLUMNS;
  }

  get totalItems(): number {
    const offers = this.dashboardData && this.dashboardData.SellerOffers;
    return offers ? offers.length : 0;
  }

  get formattedRows(): any[] {
    const offers = this.dashboardData && this.dashboardData.SellerOffers;
    if (!offers) { return []; }
    if (this.role === 'manager') {
      return offers.map((offer: any) => ({
        ...offer,
        quarterlyBookings:               splitData(offer.quarterlyBookings),
        totalSellersEnrolledInProgram:   splitData(offer.totalSellersEnrolledInProgram),
        totalClaimsSubmitted:            splitData(offer.totalClaimsSubmitted),
        totalBookingsClaimedBySellers:   splitData(offer.totalBookingsClaimedBySellers),
        bookingsLeftUnclaimed:           splitData(offer.bookingsLeftUnclaimed),
        totalPointsAvailable:            splitData(offer.totalPointsAvailable),
        totalSellerPointsAwarded:        splitData(offer.totalSellerPointsAwarded),
      }));
    } else {
      return offers.map((v: any) => ({
        name:            v.name,
        identifier:      v.identifier,
        bookings:        '$' + splitData(v.totalBookingsClaimed),
        claimsSubmitted: splitData(v.totalClaimsSubmitted),
        claimsPending:   splitData(v.totalClaimsPending),
        pointsEarned:    v.totalPointsEarned != null ? Number(v.totalPointsEarned).toLocaleString('en-US') : '-',
      }));
    }
  }

  get paginatedRows(): any[] {
    const start = (this.page - 1) * this.pageSize;
    return this.formattedRows.slice(start, start + this.pageSize);
  }

  onPageChange(page: number) {
    this.page = page;
  }
}
